import {
  Box,
  Image,
  Stack,
  Text,
  Tooltip,
  useColorModeValue,
} from "@chakra-ui/react";
import dayjs from "dayjs";
import { doc, onSnapshot } from "firebase/firestore";
import { useEffect, useState } from "react";
import { IoEllipseSharp, IoImageOutline } from "react-icons/io5";
import { useGetState } from "../../context/useGetState";
import { photoBaseURL } from "../../service/api";
import { db } from "../../service/firebase";
import { trunc } from "../../utils";
import thelogo from "../../assets/thelogo.png";
import { useParams } from "react-router";
var relativeTime = require("dayjs/plugin/relativeTime");
let utc = require("dayjs/plugin/utc");

dayjs.extend(utc);
dayjs.extend(relativeTime);

function ExternalUserChatProfile({ chat, onlineUsers }) {
  const { state } = useGetState();
  const usernameColor = useColorModeValue("#4B5155", "#526075");
  const [isTyping, setIsTyping] = useState({});
  const { privateUserId } = useParams();

  return (
    <Stack direction={"row"} alignItems="flex-start">
      <Box style={{ position: "relative" }}>
        <Image
          w="30px"
          h="30px"
          borderRadius={"50%"}
          objectFit="cover"
          size={"sm"}
          name={privateUserId ? chat?.name : chat?.recipient?.name}
          fallbackSrc={thelogo}
          src={privateUserId ? chat?.picture : chat?.recipient?.picture}
        />
        <Box
          style={{
            position: "absolute",
            bottom: "0px",
            right: "0px",
            color: "green",
            border: "1px solid #fff",
            borderRadius: "50%",
            backgroundColor: "#fff",
          }}
        >
          {onlineUsers?.some(
            (user) =>
              user?.userId === parseFloat(privateUserId) ||
              user?.userId === chat?.id
          ) ? (
            <IoEllipseSharp style={{ color: "green" }} size={7} />
          ) : (
            <IoEllipseSharp style={{ color: "lightgray" }} />
          )}
        </Box>
      </Box>
      <Stack alignItems={"flex-start"} spacing="-0.5">
        <Text color={usernameColor} fontSize=".8em">
          {privateUserId ? chat?.name : chat?.recipient?.name}
        </Text>

        {/* last message */}
        {chat?.last_message?.message ? (
          <Tooltip label={chat?.last_message?.message}>
            {!isTyping?.typing ||
            isTyping?.user === state?.userInfo?.username ? (
              <Text color="#7B8793" fontSize={".66em"}>
                {chat && trunc(chat?.last_message?.message, 20)}
              </Text>
            ) : (
              <Text color="#76C00D" fontSize={".7em"}>
                typing...
              </Text>
            )}
          </Tooltip>
        ) : chat?.recipient?.file ? (
          <IoImageOutline fontSize={"1em"} color="#afbbc6" />
        ) : (
          ""
        )}
      </Stack>

      {chat?.last_message?.date && (
        <Text color="#7B8793" fontSize={".7em"} flex="3" textAlign={"right"}>
          {dayjs.unix(chat?.last_message?.date?.seconds)?.fromNow(true)}
        </Text>
      )}
    </Stack>
  );
}

export default ExternalUserChatProfile;
